import { render, staticRenderFns } from "./EducatorList.vue?vue&type=template&id=8497d66e"
import script from "./EducatorList.vue?vue&type=script&lang=ts"
export * from "./EducatorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports